import { Component, Host, h, Prop, State } from '@stencil/core';

import '../loader-component/loader-component'
import '../header-component/header-component';

/**
 
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/ask-form-component.PNG)

#### Content Type
nypwebc_ct_askform
 */


@Component({
  tag: 'ask-form-component',
  styleUrl: 'ask-form-component.css',
  // shadow: true,
  scoped: true
})
export class AskFormComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
*Optional - To show/hide header. default is true
*/
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"
  /**
*entitylistfullname required
*/
  @Prop() entitylistfullname: string = ""


  /**
*anonymous default is true . if its false, then Email address field appears to the form
*/
  @Prop() anonymous: boolean = true;

  @State() items: [];
  @State() isLoading: boolean = false;
  @State() value: string;
  @State() emailaddress: string;
  @State() headertext: string = "";
  @State() footertext: string = "";
  @Prop() imageurl: string = "";



  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;


    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }

    let filter = "(nypwebc_Status eq 'XXHeader') or (nypwebc_Status eq 'XXFooter')"

    return fetch(siteUrl +  "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_PlainBody,nypwebc_Status&$filter=" + filter, { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.items.forEach((item: any) => {

          if (item.nypwebc_Status === 'XXHeader')
            this.headertext = item.nypwebc_PlainBody;
          else if (item.nypwebc_Status === 'XXFooter')
            this.footertext = item.nypwebc_PlainBody
        });

        this.isLoading = false;
      });


  }

  handleCancel = () => {

    this.value = "";
    this.emailaddress = "";

  }

  saveItem = (item) => {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;

    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }

    const digest = (window as any).document.getElementById('__REQUESTDIGEST').value
    return fetch(siteUrl +  "/_api/web/lists/getbytitle('" + this.listname + "')/items",
      {
        headers: {
          "Accept": "application/json; odata=verbose",
          "X-RequestDigest": digest,
          "Content-Type": "application/json;odata=verbose"
        },
        method: "POST",
        body: JSON.stringify(item),
      })
      .then(response => response.json())
      .then(data => {

        if (data.d && data.d.ID) {
          console.log(data.d.ID)
          alert("You question or concern submitted successfully. Thank you");
          this.value = "";
          this.emailaddress = "";
        }
        else {
          alert("we ran into issues. please try again and if that did not help, please contact webdev. Thank you");
        }

      }).catch(error => console.log("rest api error is:" + error));

  }

  handleSubmit = () => {

    if (this.anonymous) {
      if (this.value) {
        var item = {
          'Title': this.emailaddress,
          'nypwebc_PlainBody': this.value,
          '__metadata': { 'type': this.entitylistfullname },
        };
        this.saveItem(item);
      }
      else {
        alert("Please enter your questions or concerns before you click submit");
      }
    }
    else {
      if (this.value && this.emailaddress && this.isEmail(this.emailaddress)) {
        var item = {
          'Title': this.emailaddress,
          'nypwebc_PlainBody': this.value,
          '__metadata': { 'type': this.entitylistfullname },
        };
        this.saveItem(item);
      }
      else {
        alert("Please enter valid email and questions or concerns before you click submit");
      }
    }

  }



  // if (this.value) {
  //   var item = {
  //     'Title': this.fullname,
  //     'nypwebc_PlainBody': this.value,
  //     '__metadata': { 'type': this.entitylistfullname },
  //   };
  // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
  // const digest = (window as any).document.getElementById('__REQUESTDIGEST').value

  // return fetch(siteUrl + this.webpath + "/_api/web/lists/getbytitle('" + this.listname + "')/items",
  //   {
  //     headers: {
  //       "Accept": "application/json; odata=verbose",
  //       "X-RequestDigest": digest,
  //       "Content-Type": "application/json;odata=verbose"
  //     },
  //     method: "POST",
  //     body: JSON.stringify(item),
  //   })
  //   .then(response => response.json())
  //   .then(data => {

  //     if (data.d && data.d.ID) {
  //       console.log(data.d.ID)
  //       alert("You question or concern submitted successfully. Thank you");
  //       this.value = "";
  //       this.fullname = "";
  //     }
  //     else {
  //       alert("we ran into issues. please try again and if that did not help, please contact webdev. Thank you");
  //     }

  //   }).catch(error => console.log("rest api error is:" + error));

  // }
  // else  {
  //   alert("Please enter you questions or concers before you click submit");
  // }



  // }

  handleChange(event) {
    this.value = event.target.value;


    if (event.target.validity.typeMismatch) {
      console.log('this element is not valid')
    }
  }


  handleNameChange(event) {
    this.emailaddress = event.target.value;


    if (event.target.validity.typeMismatch) {
      console.log('this element is not valid')
    }
  }

  isEmail(email) {
    var regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regexp.test(String(email).toLowerCase());
  }

  render() {

    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }

    return (
      this.isLoading ? <loader-component /> :
        this.header ?
          <div>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>
                <div style={{ marginTop: "20px" }} >
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        {this.headertext}
                      </div>
                    </div>
                    <div class="row mb-3 mt-3">

                      {!this.anonymous ? <div class="col-md-12" >
                        <div class="form-floating">
                          <input type="email" name="emailaddress" class="form-control" value={this.emailaddress} placeholder="Enter your Email Address" onInput={(e) => this.handleNameChange(e)}></input>
                          <label >Enter your Email address</label>
                        </div>
                      </div> : null}
                    </div>
                    {this.imageurl != "" ?
                      <div class="row" >
                        <div class="col-md-10 mt-3" >
                          <div class="form-floating">
                            <textarea class="form-control" value={this.value} placeholder="Leave a comment here" style={{ height: "200px" }} onInput={(e) => this.handleChange(e)}></textarea>
                            <label >Leave a comment here</label>
                          </div>
                        </div>
                        <div class="col-md-2 mt-3 " >
                          <img src={this.imageurl}  class="img-fluid mx-auto d-block"  />
                        </div>
                      </div>
                      :
                      <div class="row">
                        <div class="col-md-12 mt-3" >
                          <div class="form-floating">
                            <textarea class="form-control" value={this.value} placeholder="Leave a comment here" style={{ height: "200px" }} onInput={(e) => this.handleChange(e)}></textarea>
                            <label >Leave a comment here</label>
                          </div>
                        </div>
                      </div>
                    }

                    <div class="row">
                      <div class="col-md-12">
                        {this.footertext}
                      </div>
                    </div>
                  
                  <div class="row mb-3 mt-3  float-end">
                    <div class="col-md-12">
                      <button class="btn btn-danger" type="button" onClick={this.handleSubmit}> Submit </button>
                      <button class="btn btn-secondary" type="button" onClick={this.handleCancel} style={{ marginLeft: "25px" }}> Cancel </button>
                    </div>
                  </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
       
          :
    <div class="row gx-0" style={parentstyle} >
      <div style={style}>
        <div style={{ marginTop: "20px" }} >

          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                {this.headertext}
              </div>
            </div>
            <div class="row mb-3 mt-3">
              {!this.anonymous ? <div class="col-md-12" >
                <div class="form-floating">
                  <input type="text" name="emailaddress" class="form-control" value={this.emailaddress} placeholder="Enter your Email address" onInput={(e) => this.handleNameChange(e)}></input>
                  <label >Enter your Email Address</label>
                </div>
              </div> : null}
            </div>
            {this.imageurl != "" ?
              <div class="row">
                <div class="col-md-10 mt-3 " >
                  <div class="form-floating">
                    <textarea class="form-control" value={this.value} placeholder="Leave a comment here" style={{ height: "200px" }} onInput={(e) => this.handleChange(e)}></textarea>
                    <label >Leave a comment here</label>
                  </div>
                </div>
                <div class="col-md-2 mt-3 " >
                  <img src={this.imageurl} class="img-fluid mx-auto d-block"  />
                </div>
              </div> :
              <div class="col-md-12 mt-3 " >
                <div class="form-floating">
                  <textarea class="form-control" value={this.value} placeholder="Leave a comment here" style={{ height: "200px" }} onInput={(e) => this.handleChange(e)}></textarea>
                  <label >Leave a comment here</label>
                </div>
              </div>
            }

            <div class="row mb-3 mt-3 float-end">
              <div class="col-md-5">
                <button class="btn btn-danger" type="button" onClick={this.handleSubmit}> Submit </button>
              </div>
              <div class="col-md-2">

              </div>
              <div class="col-md-5">
                <button class="btn btn-secondary" type="button" onClick={this.handleCancel}> Cancel </button>
              </div>

            </div>
            <div class="row ">
              <div class="col-md-12">
                {this.footertext}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    );
  }

}
